import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
//I jave left it blank you will copy and paste it from your firebase config mentioned in pic above
const firebaseConfig = {
    apiKey: "AIzaSyB_uEC22UvGOY5wksiDL8h1TTB6TP9vsxM",
    authDomain: "vueblog-dd1d3.firebaseapp.com",
    projectId: "vueblog-dd1d3",
    storageBucket: "vueblog-dd1d3.appspot.com",
    messagingSenderId: "932739488748",
    appId: "1:932739488748:web:52239ad08b98ba72863ec9"
};

firebase.initializeApp(firebaseConfig)

firebase.getCurrentUser = () => {
    return new Promise((resolve, reject) => {
        const unsubscribe = firebase.auth().onAuthStateChanged(user => {
            unsubscribe();
            resolve(user);
        }, reject);
    })
};

const db = firebase.firestore();
//Get access to firebase database
const appAuth = firebase.auth();
//get access to authentication in firebase

export { db, appAuth }